import React from 'react';
import { whyPramal } from '../../data/mock';
import { User, Target, Hammer, Briefcase, Gauge, CheckCircle2 } from 'lucide-react';
import { useScrollAnimation } from '../../hooks/use-scroll-animation';

const iconMap = {
  User,
  Target,
  Hammer,
  Briefcase,
  Gauge
};

const FeatureItem = ({ item, IconComponent, index }) => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.1 });

  return (
    <div
      ref={ref}
      className={`group flex items-center gap-5 p-6 rounded-2xl bg-white/80 backdrop-blur-sm hover:bg-white border border-slate-200/60 hover:border-slate-300 hover:shadow-premium-lg transition-all duration-500 cursor-default hover:-translate-x-1 ${
        isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
      }`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-slate-100 to-slate-50 shadow-premium flex items-center justify-center flex-shrink-0 group-hover:from-slate-900 group-hover:to-slate-800 group-hover:shadow-premium-lg transition-all duration-500 group-hover:scale-110">
        <IconComponent className="w-6 h-6 text-slate-700 group-hover:text-white transition-colors duration-500" />
      </div>
      <span className="text-lg font-bold text-slate-800 group-hover:text-slate-900 transition-colors">
        {item.title}
      </span>
    </div>
  );
};

export const WhyPramalSection = () => {
  const [leftRef, leftVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section id="why-pramal" className="py-32 lg:py-40 bg-gradient-to-b from-white to-slate-50/50 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-slate-100/40 to-transparent rounded-full blur-3xl opacity-50 animate-float-slow" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          {/* Premium Left Content */}
          <div 
            ref={leftRef}
            className={`transition-all duration-700 ${
              leftVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-6'
            }`}
          >
            <span className="text-sm font-bold text-slate-500 uppercase tracking-widest mb-4 inline-block">Why Choose Us</span>
            <h2 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight leading-tight">
              Why Work With Pramal IT Services?
            </h2>
            <p className="mt-6 text-xl text-slate-600 leading-relaxed font-medium">
              We're builders who think like founders, not typical outsourcing.
            </p>
          </div>

          {/* Premium Features List */}
          <div className="space-y-4">
            {whyPramal.map((item, index) => {
              const IconComponent = iconMap[item.icon] || CheckCircle2;
              return (
                <FeatureItem
                  key={item.id}
                  item={item}
                  IconComponent={IconComponent}
                  index={index}
                />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
